import { render, staticRenderFns } from "./DonutModule.vue?vue&type=template&id=15277864&scoped=true&"
import script from "./DonutModule.vue?vue&type=script&lang=js&"
export * from "./DonutModule.vue?vue&type=script&lang=js&"
import style0 from "./DonutModule.vue?vue&type=style&index=0&id=15277864&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15277864",
  null
  
)

export default component.exports